module.exports = __webpack_public_path__ + "img/avatar.14ffa5eb.jpg";